export var variants = {'sans-12':'$X4Erz','sans-14':'$_2vF89','sans-16':'$_36K0J','sansCond-13':'$z11f5','sansCond-16':'$_2WIUV','sansCond-20-30':'$_1mGiu'};